import { axios } from '@/utils/request'

const api = {
  enterpriseContract: '/enterprise/contract'
}

export function getEnterpriseContractList (parameter) {
  return axios({
    url: api.enterpriseContract + '/list',
    method: 'get',
    params: parameter
  })
}

export function saveEnterpriseContract (parameter) {
  return axios({
    url: api.enterpriseContract+(parameter.id > 0 ? '/update' : '/save'),
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function delEnterpriseContract (parameter) {
  return axios({
    url: api.enterpriseContract + '/remove',
    method: 'post',
    params: parameter
  })
}

export const enterpriseContractExport = api.enterpriseContract + '/export'
